import { ECheckDailyrentPriceActionTypes } from 'shared/actions/checkDailyrentPrice/types';
import { EActionType } from 'shared/types/dailyrent';
import { IOfferData } from 'shared/types/offerData';
import { RootAction } from 'shared/types/redux/RootAction';

import { EDailyrentActionTypeTypes } from '../../actions/dailyrentActionType';

export type TDailyrentActionTypeState = EActionType | null;

/**
 * С бэка приходит actionType – от него зависит, какие кнопки отрисуются в карточке.
 * @param state
 * @param action
 */
export function dailyrentActionTypeReducer(
  state: TDailyrentActionTypeState = null,
  action: RootAction,
): TDailyrentActionTypeState {
  switch (action.type) {
    case 'IOfferFetched': {
      return (action.offerData as IOfferData).offer.dailyrent?.actionType || null;
    }

    case ECheckDailyrentPriceActionTypes.Success: {
      return action.payload.actionType || null;
    }

    case EDailyrentActionTypeTypes.SetActionType: {
      return action.payload;
    }

    default:
      return state;
  }
}
